import { FC } from "react";
import imagePng from 'images/hero-right.png';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col lg:flex-col relative ${className} mt-0`}
      data-nc-id='SectionHero'
    >
      <div className='z-10 mb-12 lg:-mb-28 w-full flex justify-center'>
        <HeroSearchForm />
      </div>

      <div className='flex flex-col lg:flex-row lg:items-center'>
        <div className='flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0 lg:mt-60'>
          <h2 className='font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%]'>
            Bus, Hotel, Launch & More
          </h2>
          <span className='text-base md:text-lg text-neutral-500 dark:text-neutral-400'>
            Accompanying us, you have a trip full of experiences. With
            TicketsForTravel, booking hotel, bus, launch & flights
          </span>
          <ButtonPrimary>Download Our App</ButtonPrimary>
        </div>
        <div className='flex-grow'>
          <img className='w-full' src={imagePng} alt='hero' />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;


// 02, 60, d7